export * from './normalizeZipCode';
export * from './denormalizeZipCode';
export * from './normalizeWeight';

export { normalizePhone, denormalizePhone } from '@farmersdog/utils';
